export default __webpack_public_path__ + "static/media/HTMLlogo.svg.b7d94634.png";